<template src="./Index.html" />


<script>

export default {

  created() {
    this.$store.dispatch("salaryDoctorsReport/getDoctors");
  },
  computed: {

    doctors() {
      return this.$store.state.salaryDoctorsReport.doctors;
    },
    doctorAmount() {
      var doctorProfit = 0;
       this.salaryDoctors.forEach(x => doctorProfit+=x.doctorProfit)
       console.log(doctorProfit);
       var operatingAmount = 0;
       this.salaryDoctors.forEach(x => operatingAmount+=x.operatingAmount)
       console.log(operatingAmount);
     return (
    Number(doctorProfit || 0) -
    Number(operatingAmount || 0) -
    Number(this.settlementAmount || 0)
  );
}
  },

  data() {
    return {
      salaryDoctors: [],
      settlementAmount:null,
      dialog: false,
      dialogMessage: "",
      doctorInfo: {},
      hasResult: false,
      filters: {
        doctorId: null,
        fromDate: null,
        toDate: null,
      },
      headers: [
        // { text: 'اسم الطبيب', value: 'fullName' },
        { text: 'الشهر', value: 'month' },
        { text: "الاجمالي", value: "total", sortable: false },
        { text: "القيمة التشغيلية", value: "operatingAoumt", sortable: false },
        { text: "قيمة الطبيب", value: "doctorProfit", sortable: false },
      ],
salaryHeaders: [
  { text: 'تصنيف الخدمة', value: 'classification' },
  { text: 'نسبة الطبيب', value: 'commissionRate' },
  { text: 'النسبة التشغيلية', value: 'operatingExpenseRatio' },
  { text: 'الإجمالي', value: 'total' },
  { text: 'قيمة الطبيب', value: 'doctorProfit' },
  { text: 'القيمة التشغيلية', value: 'operatingAmount' },
],
    };
  },
  methods: {
    formatCurrency(val) {
      if (!val) return "0";
      return Number(val).toLocaleString();
    },
    getAll(page) {
      this.filters.page = page || 1;
      this.$store.dispatch("salaryDoctorsReport/getAll", this.filters).then((res) => {
        this.hasResult = res.salaryDoctors.length > 0;
        this.salaryDoctors = res.salaryDoctors
        this.doctorInfo = res.doctorInfo
        this.settlementAmount = res.settlementAmount
      });

    },
    // // -------------- end empDialog  -----
    showDialog() {
      let doctorName = this.doctors.find(x => x.value == this.filters.doctorId)?.label;
      this.dialogMessage = `هل انت متأكد من رغبتك بتسوية قيمة ${this.doctorAmount} للطبيب ${doctorName} في الفترة المختارة ؟`;

      this.dialog = true;
    },


    confirmDialog() {
      
      this.$store.dispatch(`salaryDoctorsReport/createSettlement`, this.filters);
      this.cancelDialog();
    },

    cancelDialog() {
      this.filters.doctorId = null;
      this.filters.fromDate = null;
      this.filters.toDate = null;
      this.salaryDoctors = [];
      this.settlementAmount = null;
      this.hasResult = false;
      this.dialog = false;
    },


    resetForm() {
     this.salaryDoctors = [];
           this.settlementAmount = null;

      this.hasResult = false;
    },


  }
};
</script>
